import { notificationMixin } from './notificationMixin';

export const dropzoneMixin = {
  mixins: [notificationMixin],

  methods: {
    $_dropzoneMixin_handleFileTypeError(uploaderRef, file, message) {
      const isFileTypeError = message === "You can't upload files of this type.";

      if (isFileTypeError) {
        const { acceptedFiles = '' } = uploaderRef.options;

        uploaderRef.removeFile(file);

        this.notiIncorrectImageType(acceptedFiles);
      }

      return isFileTypeError;
    },

    $_dropzoneMixin_handleFileSizeError(uploaderRef, file, message) {
      const isFileSizeError = message.includes('Max filesize');

      if (message.includes('Max filesize')) {
        const { maxFilesize = '' } = uploaderRef.options;

        uploaderRef.removeFile(file);

        this.notiIncorrectFileSize(maxFilesize);
      }

      return isFileSizeError;
    },

    $_dropzoneMixin_handleServerRespondedError(_uploaderRef, file, message) {
      const match = message.includes('Server responded with');

      if (match) {
        file.previewElement.classList.remove('dz-file-preview');

        this.$_dropzoneMixin_updateErrorMessage(file, 'File upload failed.');

        this.notiError('File upload failed.');
      }

      return match;
    },

    $_dropzoneMixin_updateErrorMessage(file, message) {
      const errorMessage = file.previewElement.querySelector('[data-dz-errormessage]');

      if (errorMessage) {
        errorMessage.innerHTML = message;
      }
    },

    $_dropzoneMixin_hasUploadingOrErrorFiles(uploaderRef) {
      console.log('getFilesWithStatus', uploaderRef.getFilesWithStatus());
      console.log('getActiveFiles', uploaderRef.getActiveFiles());
      console.log('getAddedFiles', uploaderRef.getAddedFiles());
      console.log('getAcceptedFiles', uploaderRef.getAcceptedFiles());
      console.log('getRejectedFiles', uploaderRef.getRejectedFiles());
      console.log('getQueuedFiles', uploaderRef.getQueuedFiles());
      console.log('getUploadingFiles', uploaderRef.getUploadingFiles());
    }
  }
};
